/* Gentle hero motion and caption rotation. No canvas or glitch rendering. */
(()=>{'use strict';
const hero=document.querySelector('[data-home-rf]');
if(!hero||hero.dataset.ready)return;
hero.dataset.ready='true';
const stages=[['End-user devices','Purpose-built field devices.'],['Sensors and trackers','Connected RF sensors.'],['Communications','Keep your team connected.'],['Mission hardware','Mission-ready hardware.']];
const buttons=[...hero.querySelectorAll('[data-rf-stage]')];
const control=hero.querySelector('[data-rf-motion]');
const photo=hero.querySelector('.field-photo');
const defaultPhoto=photo?{src:photo.getAttribute('src'),width:photo.width,height:photo.height}:null;
const sensorsSrc=photo?.dataset.sensorsSrc;
if(photo)[sensorsSrc,photo.dataset.otherSrc,photo.dataset.fieldKitSrc].filter(Boolean).forEach(src=>{const preload=new Image();preload.src=src;});
const reduced=matchMedia('(prefers-reduced-motion: reduce)');
let stage=0,elapsed=0,last=0,raf=0,visible=true,paused=reduced.matches;
let captionAnimation=null,photoAnimation=null;
function fadePhoto(){
 photoAnimation?.cancel();
 if(photo&&!paused&&!reduced.matches){
  photoAnimation=photo.animate([{opacity:0,transform:'scale(1.035)'},{opacity:1,transform:'scale(1)'}],{duration:4000,easing:'ease-out'});
 }
}
function setStage(index){
 stage=index;elapsed=0;
 hero.classList.toggle('is-eud',index===0);
 hero.classList.toggle('is-comms',index===2);
 hero.classList.toggle('is-field-kit',index===3);
 if(photo&&sensorsSrc){
  const sensors=index===1;
  hero.classList.toggle('is-sensors',sensors);
  photo.src=sensors?sensorsSrc:index===0?defaultPhoto.src:index===3?photo.dataset.fieldKitSrc:(photo.dataset.otherSrc||defaultPhoto.src);
  photo.width=sensors?1280:index===0?defaultPhoto.width:3840;
  photo.height=sensors?863:index===0?defaultPhoto.height:2160;
 }
 fadePhoto();
 buttons.forEach(button=>button.style.setProperty("--progress","0"));
 hero.querySelector('[data-rf-count]').textContent=String(index+1).padStart(2,'0');
 hero.querySelector('[data-rf-caption-title]').textContent=stages[index][0];
 hero.querySelector('[data-rf-caption-copy]').textContent=stages[index][1];
 buttons.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)));
 if(!paused&&!reduced.matches){
  captionAnimation?.cancel();
  captionAnimation=hero.querySelector('.rf-caption').animate([{opacity:0,translate:'0 6px'},{opacity:1,translate:'0 0'}],{duration:600,easing:'ease-out'});
 }
}
buttons.forEach((button,i)=>button.addEventListener('click',()=>setStage(i)));
function tick(now){
 raf=0;
 if(paused||!visible||document.hidden)return;
 elapsed+=last?Math.min(now-last,100):0;last=now;
 if(elapsed>=7000)setStage((stage+1)%stages.length);
 buttons[stage].style.setProperty('--progress',String(elapsed/7000));
 raf=requestAnimationFrame(tick);
}
function sync(){
 cancelAnimationFrame(raf);raf=0;last=0;
 hero.dataset.motionPaused=String(paused);
 control.setAttribute('aria-label',paused?'Play animation':'Pause animation');
 control.querySelector('path').setAttribute('d',paused?'M5 3l8 5-8 5Z':'M5 3v10M11 3v10');
 if(paused){captionAnimation?.cancel();photoAnimation?.cancel();}
 if(!paused&&visible&&!document.hidden)raf=requestAnimationFrame(tick);
}
control.addEventListener('click',()=>{paused=!paused;sync();});
reduced.addEventListener('change',()=>{paused=reduced.matches;sync();});
new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;sync();},{threshold:.01}).observe(hero);
document.addEventListener('visibilitychange',sync);
sync();
fadePhoto();
})();
